import { render, staticRenderFns } from "./activeDetail.vue?vue&type=template&id=0fa848e8&"
import script from "./activeDetail.vue?vue&type=script&lang=js&"
export * from "./activeDetail.vue?vue&type=script&lang=js&"
import style0 from "./activeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports